import { render } from "./ExternalVmsEvents.vue?vue&type=template&id=5af069da&ts=true"
import script from "./ExternalVmsEvents.vue?vue&type=script&lang=tsx"
export * from "./ExternalVmsEvents.vue?vue&type=script&lang=tsx"

import "./ExternalVmsEvents.vue?vue&type=style&index=0&id=5af069da&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__